import { createContext, useContext, useState, type ReactNode } from "react";
import PartnershipDrawer, { type PartnershipTier } from "@/components/PartnershipDrawer";

type SpeakerApplicationTier = Exclude<PartnershipTier, null>;

interface SpeakerApplicationContextValue {
  openSpeakerApplication: (tier?: SpeakerApplicationTier) => void;
  closeSpeakerApplication: () => void;
}

const SpeakerApplicationContext = createContext<SpeakerApplicationContextValue | null>(null);

export function SpeakerApplicationProvider({ children }: { children: ReactNode }) {
  const [tier, setTier] = useState<PartnershipTier>(null);

  const openSpeakerApplication = (nextTier: SpeakerApplicationTier = "speaker") => setTier(nextTier);
  const closeSpeakerApplication = () => setTier(null);

  return (
    <SpeakerApplicationContext.Provider value={{ openSpeakerApplication, closeSpeakerApplication }}>
      {children}
      <PartnershipDrawer tier={tier} onClose={closeSpeakerApplication} />
    </SpeakerApplicationContext.Provider>
  );
}

export function useSpeakerApplication() {
  const context = useContext(SpeakerApplicationContext);
  if (!context) throw new Error("useSpeakerApplication must be used within SpeakerApplicationProvider");
  return context;
}
